import CustomSkinHelper from '@/pages/product/components/CustomSkin/helper';
import { ExtraServiceType } from '@/types/extraService';
import ThirdPartyPlatformConfig from '@/utils/configs/ThirdPartyPlatform.config';
import { isNeedHidePriceProduct } from '@/utils/configs/product.config';

/** 判断是否是定制贴商品 */
export const isCustomProduct = (pid: number) => {
  // 不能直接加购产品列表（定制贴商品）
  const customProductIds = CustomSkinHelper.CustomSkinPidList;
  return customProductIds.includes(pid);
};

export const isX3X4 = (pid: number) => {
  return [19, 26].includes(pid);
};

/**
 * 商品名移除品牌名称
 */
export const removeBrandName = (productName: string) => {
  const brandName = ['影石Insta360', 'Insta360', 'insta360'];

  const res = brandName.reduce((prev, brand) => {
    const regExp = new RegExp(brand, 'g');
    return prev.replace(regExp, '');
  }, productName);

  return res.trim();
};

/** 加入购物车类型 */
export const enum AddToCartType {
  /** 8k直播 */
  EIGHT_K = '8k',
  /** 缺货 */
  OUT_OF_STOCK = 'out_of_stock',
  /** 第三方导流商品/套餐，点击跳转产品页 */
  THIRD_PARTY = 'third_party',
  /** 增值服务 */
  EXTRA_SERVICE = 'extra_service',
  /** 定制贴商品 */
  CUSTOM_PRODUCT = 'custom_product',
  /** 需要隐藏价格的商品 */
  NEED_HIDE_PRICE = 'need_hide_price',
  /** 正常商品 */
  NORMAL = 'normal',
}

export const getCommodityAddToCartType = (commodity: {
  pid: number;
  cid: number;
  stockCount?: number;
  commoditySaleState?: number;
  serviceType?: `${ExtraServiceType}`;
}): AddToCartType => {
  const { pid, cid, stockCount, commoditySaleState, serviceType } = commodity;
  // 8k直播
  if (pid === 258) {
    return AddToCartType.EIGHT_K;
  }
  // 缺货
  if ((stockCount !== undefined && stockCount <= 0) || (commoditySaleState !== undefined && commoditySaleState < 0)) {
    return AddToCartType.OUT_OF_STOCK;
  }
  // 增值服务
  if (serviceType && Object.values(ExtraServiceType).includes(serviceType as ExtraServiceType)) {
    return AddToCartType.EXTRA_SERVICE;
  }

  const redirectData = ThirdPartyPlatformConfig.getRedirectData({
    pid: pid,
    cid: cid,
  });
  // 第三方导流商品
  if (redirectData.url) {
    return AddToCartType.THIRD_PARTY;
  }
  // 定制贴商品
  if (isCustomProduct(pid)) {
    return AddToCartType.CUSTOM_PRODUCT;
  }

  // 需要隐藏价格的商品
  if (isNeedHidePriceProduct(pid)) {
    return AddToCartType.NEED_HIDE_PRICE;
  }
  // 正常商品
  return AddToCartType.NORMAL;
};
